import { cardList } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'cardList',
  label: 'CardList',
  category: 'Data Display',
  image: cardList
};
